import { LockedPayoutAccount } from "../../common/requests/transactions/endpoints";

const COUNTRIES: Record<string, string> = { SG: "Singapore", ID: "Indonesia", TH: "Thailand", MY: "Malaysia" };
const WEEK = 7 * 86400000;

export const countryName = (code: string) => COUNTRIES[code] ?? code;

/** "DBS / POSB", "PayNow (mobile)". */
export function accountTitle(account: LockedPayoutAccount): string {
  if (account.method === "paynow") return `PayNow (${account.paynow_type === "uen" ? "UEN" : "mobile"})`;
  return account.bank_name ?? "Bank account";
}

/** "DBS / POSB •••• 4821". */
export const maskedLabel = (account: LockedPayoutAccount) => `${accountTitle(account)} •••• ${account.last4}`;

/** Details changed (not first saved) in the last 7 days: worth a second look before paying. */
export function recentlyChanged(account: LockedPayoutAccount, now: Date = new Date()): boolean {
  const change = account.last_change;
  if (!change?.changed_at || !change.old_last4) return false;
  return now.getTime() - new Date(change.changed_at).getTime() < WEEK;
}
